export default "__VITE_ASSET__Ddgj66VE__"